<template>
  <div>
    <p v-if="isInnerMessage" :class="pClass" v-html="parsedMessage" />
    <span v-else :class="spanClass" v-html="parsedMessage" />
  </div>
</template>

<script>
import { variablesInspection } from '@/modules/maria/campanha-da-maria-v2/mixins/variables-inspection.js'
export default {
  name: 'PushPreview',
  mixins: [variablesInspection],
  computed: {
    isInnerMessage() {
      return this.field === 'inner_message_title' || this.field === 'inner_message_text'
    },
    spanClass() {
      return this.field === 'title' ? 'primary-text push-title' : 'secondary-text push-caption'
    },
    pClass() {
      return this.field === 'inner_message_title' ? 'mf-h6' : 'mf-subtitle-1'
    },
  },
}
</script>

<style lang="scss" scoped>
p,
span {
  max-width: inherit;
  max-height: inherit;
  word-wrap: break-word;
}

.push-title {
  padding-left: 1.6vw;
  font-size: 20px;
  display: block;
}

::v-deep .variable-style {
  font-weight: bold;
  white-space: nowrap;
  color: #9747ff;
}

::v-deep .subvariable-style {
  font-weight: bold;
  white-space: nowrap;
  color: $cinza-d20;
}
</style>
